import React from 'react';

export default function VerticalRect(): JSX.Element {
  return <div style={{ height: '100%', width: '20px', backgroundColor: '#606060' }}></div>;
}
